<template>
    <b-container fluid>
        <page-title>
            <h2>
                <router-link :to="{ name: 'ReportList' }" class="nav-link">Raporty</router-link>
            </h2>
        </page-title>

        <div class="col page-element">
            <!-- <alert-loading v-if="loading"></alert-loading> -->

            <b-card v-if="!loading" no-body>
                <b-tabs ref="tabs" card :lazy="true">
                    <b-tab v-for="item in currencyTypes" :title="'Obroty (' + item.name + ')'"  >
                        <ReportSales :currency="item"></ReportSales>
                    </b-tab>
                    <b-tab v-for="item in currencyTypes" :title="'Wierzytelności ('+ item.name + ')'">
                        <ReportDebts :currency="item"></ReportDebts>
                    </b-tab>
                    <b-tab v-for="item in currencyTypes" :title="'Sprzedaż ('+ item.name + ')'">
                        <ReportInvoice :currency="item"></ReportInvoice>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </b-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import ReportSales from './Sales.vue'
  import ReportInvoice from './Invoice.vue'
  import ReportDebts from './Debts.vue'

  export default {
    components: {
      ReportSales,
      ReportInvoice,
      ReportDebts,
    },
    computed: {
      ...mapGetters({
        currencyTypes: 'config/config/currencyTypes'
      })
    },
    created () {
      this.$store.dispatch('agreement/list/getItems')
    }
  }
</script>


// WEBPACK FOOTER //
// List.vue?70d3ce79